import React, { ReactNode, useContext, useState } from 'react';
import { View } from '@shared/components/View';
import { MBHover } from '@shared/components/hover';
import { MBIconV2 } from '@shared/components/image';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { MBTextOverlineBold } from '@shared/components/typography';
import { ColorThemeContext, Colors, grid } from '@shared/styles';
import { i18n } from '@shared/util/i18n';

interface Props {
  onPressArchive?: VoidFunction;
  onCheckToggle?: VoidFunction;
  isChecklistEnabled?: boolean;
  isCheckedOn?: boolean;
  isCheckedOff?: boolean;
  tagForegroundColor: string;
  tagBackgroundColor?: string;
  children: ReactNode;
}

export function TagOptionRow({
  onPressArchive,
  onCheckToggle,
  isChecklistEnabled,
  isCheckedOn,
  isCheckedOff,
  tagBackgroundColor = Colors.v2.tagGray,
  tagForegroundColor,
  children,
}: Props) {
  const colors = useContext(ColorThemeContext);
  const [isHovered, setIsHovered] = useState<boolean>(false);
  const [isIconHovered, setIsIconHovered] = useState<boolean>(false);

  return (
    <MBHover onHoverStart={() => setIsHovered(true)} onHoverEnd={() => setIsHovered(false)}>
      {isChecklistEnabled && (
        <View paddingHorizontal={3} paddingTop={2} paddingBottom={0.5}>
          <MBTextOverlineBold color={colors.foregroundInactive}>
            {isCheckedOn
              ? i18n('workflowTemplate.component.tag.checked')
              : i18n('workflowTemplate.component.tag.unchecked')}
          </MBTextOverlineBold>
        </View>
      )}
      <View row paddingBottom={2} paddingVertical={1} paddingRight={2} centerVertically>
        {isHovered ? (
          <MBHover
            onHoverStart={() => setIsIconHovered(true)}
            onHoverEnd={() => setIsIconHovered(false)}
          >
            <MBIconV2
              name="dots-grab-narrow"
              color={isIconHovered ? colors.input.foregroundInactive : colors.input.label}
              size={grid(3)}
            />
          </MBHover>
        ) : (
          <View style={{ width: grid(3), height: grid(3) }} />
        )}
        <View
          style={{
            width: grid(4),
            height: grid(4),
            borderRadius: grid(2),
            backgroundColor: tagBackgroundColor,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <MBIconV2 name="tag" color={tagForegroundColor} size={grid(3)} />
        </View>
        {children}
        {isChecklistEnabled && isCheckedOn && (
          <MBTouchableOpacity onPress={onCheckToggle} style={{ marginRight: grid(0.5) }}>
            <MBIconV2 name="check-box" color={colors.foregroundActive} size={grid(3)} />
          </MBTouchableOpacity>
        )}
        {isChecklistEnabled && isCheckedOff && (
          <MBTouchableOpacity onPress={onCheckToggle} style={{ marginRight: grid(0.5) }}>
            <MBIconV2 name="check-box-empty" color={colors.foregroundActive} size={grid(3)} />
          </MBTouchableOpacity>
        )}
        <MBTouchableOpacity onPress={onPressArchive}>
          <MBIconV2
            name="archive-box"
            color={onPressArchive ? colors.foregroundActive : colors.foregroundInactive}
            size={grid(3)}
          />
        </MBTouchableOpacity>
      </View>
    </MBHover>
  );
}
